import { render, staticRenderFns } from "./BulkImportBankAccountsView.vue?vue&type=template&id=0298f2ec&scoped=true"
import script from "./BulkImportBankAccountsView.vue?vue&type=script&lang=js"
export * from "./BulkImportBankAccountsView.vue?vue&type=script&lang=js"
import style0 from "./BulkImportBankAccountsView.vue?vue&type=style&index=0&id=0298f2ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0298f2ec",
  null
  
)

export default component.exports